import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {initialState, TestGroup} from "./CreateNewState";
import {
    assignTestToTestGroups,
    createNewTestGroup,
    requestAllTestGroup
} from "./CreateNewEffect";
import {DBType} from "../../services/DB.services";

export const createNewSlice = createSlice({
    name: 'counter',
    initialState,
    reducers: {},
    extraReducers: (builder => {
        // Test Groups
        builder.addCase(createNewTestGroup.fulfilled, (state, payload) => {
            state.isLoading = false;
        });

        builder.addCase(createNewTestGroup.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(createNewTestGroup.rejected, (state, action) => {
            state.isLoading = false;
            console.log(action)
        });

        builder.addCase(requestAllTestGroup.fulfilled, (state, action: PayloadAction<{
            testGroups: TestGroup[],
            dbType?: DBType,
        }>) => {
            const { dbType, testGroups } = action.payload;
            state.isLoading = false;

            if (dbType === DBType.QA) {
                state.testGroups = testGroups;
            }
            if (dbType === DBType.PROD) {
                state.testGroupsProd = testGroups;
            }
            if (dbType === DBType.DEV) {
                state.testGroupsDev = testGroups
            }
        });

        builder.addCase(requestAllTestGroup.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(requestAllTestGroup.rejected, (state, action) => {
            state.isLoading = false;
            console.log(action)
        });

        // Tests

        builder.addCase(assignTestToTestGroups.fulfilled, (state, payload) => {
            state.isLoading = false;
        });

        builder.addCase(assignTestToTestGroups.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(assignTestToTestGroups.rejected, (state, action) => {
            state.isLoading = false;
            console.log(action)
        });
    })
})

export const {  } = createNewSlice.actions

export default createNewSlice.reducer